@if (hasNewVersion) {
  <div class="alert alert-danger" role="alert">
    A new version of the app is available, please reload the website or click
    <a class="ms-1 alert-link" (click)="onReloadClick()"> here</a>
  </div>
}
@if (loader) {
  <kt-splash-screen #ktSplashScreen></kt-splash-screen>
}
<router-outlet></router-outlet>
